<template>
  <VModal ref="modal" @modal:hidden="$emit('hide')" :disable-backdrop-click="loading">
    <div class="w-full max-w-lg mx-auto">
      <BaseCard @click.stop>
        <BaseCardBody> Creating Softone Document... </BaseCardBody>
        <BaseCardBody v-if="loading">
          <Loader />
        </BaseCardBody>
        <BaseCardBody v-else-if="rejected">
          {{ errorMessage }}
        </BaseCardBody>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
import { accOrderSoftOneDocumentsClient } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';
import { ACC_ORDERS, THIRD_PARTY_SERVICE_DOCUMENTS } from '@/store/entities/schema_types';

export default {
  props: {
    orderId: {
      type: String,
      required: true,
    },
    thirdPartyServiceId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      rejected: false,
      errorMessage: '',
    };
  },
  computed: {
    order() {
      return this.$store.state.entities.accOrders.byId[this.orderId];
    },
  },
  created() {
    this.createDocument();
  },
  methods: {
    setLoading(loading = true) {
      this.loading = loading;
    },
    setRejected(rejected = true) {
      this.rejected = rejected;
    },
    async createDocument() {
      try {
        this.setLoading();

        const response = await accOrderSoftOneDocumentsClient.store(
          this.order.id,
          mapKeysToSnakeCase({
            thirdPartyServiceId: this.thirdPartyServiceId,
          })
        );

        const thirdPartyServiceDocumentId = await this.$store.dispatch('entities/persistEntities', {
          type: THIRD_PARTY_SERVICE_DOCUMENTS,
          data: response.data,
        });

        await this.addThirdPartyServiceDocumentToOrder(thirdPartyServiceDocumentId);

        this.$refs.modal.close();
      } catch (error) {
        this.errorMessage = error.response?.message || 'Failed creating document.';
        this.setRejected();
      } finally {
        this.setLoading(false);
      }
    },
    async addThirdPartyServiceDocumentToOrder(thirdPartyServiceDocumentId) {
      try {
        await this.$store.dispatch('entities/persistEntities', {
          type: ACC_ORDERS,
          data: {
            id: this.order.id,
            thirdPartyServiceDocuments: [
              ...(this.order?.thirdPartyServiceDocuments || []),
              thirdPartyServiceDocumentId,
            ],
          },
        });
      } catch (error) {
        //
      }
    },
  },
};
</script>
